export var DiscountType;
(function (DiscountType) {
    DiscountType["DISCOUNT_TYPE_UNSPECIFIED"] = "DISCOUNT_TYPE_UNSPECIFIED";
    /** Discount is a fixed amount in USD. */
    DiscountType["FIXED_AMOUNT"] = "FIXED_AMOUNT";
    /** Discount is a percentage of the total price. */
    DiscountType["PERCENTAGE"] = "PERCENTAGE";
})(DiscountType || (DiscountType = {}));
export var DurationUnit;
(function (DurationUnit) {
    /** unknown interval unit */
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** month */
    DurationUnit["MONTH"] = "MONTH";
    /** year */
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var TaxType;
(function (TaxType) {
    TaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxType["VAT"] = "VAT";
    TaxType["GST"] = "GST";
})(TaxType || (TaxType = {}));
//# sourceMappingURL=types.impl.js.map